import {Textarea} from '../../../../../../../components/textarea-legacy/Textarea'
import styled from 'styled-components'

export const NotesTextArea = styled(Textarea)`
    margin-top: 32px;
`
